import type { FilmComment } from "../types/entities/filmDetail"

const DISABLED_PATTERN = /комментар.*отключ|отключ.*комментар/i

export const COMMENTS_DISABLED_MEME_PHRASES = [
    "«I'll be back» — отзывы ушли в intermission, но обещали вернуться.",
    "«Say hello to my little friend!» — а вот лента комментариев сейчас на перемотке.",
    "«Mamma mia! Here we go again» — только секция отзывов закрыта на ремонт.",
    "«Bond. James Bond.» — с лицензией на молчание до второй серии.",
    "«Hasta la vista, baby» — комментарии временно в другом кинотеатре.",
    "«Шире, шире, ещё шире экран!» — а лента отзывов пока сузилась до нуля.",
    "«Королева — в холодильнике, отзывы — на паузе» — классика жанра.",
    "«Твои отзывы мне не нужны, Данко» — сказал модератор и ушёл в закат.",
    "«Это шедевр!» — крикнул критик. Комментарии: «мы ещё подумаем».",
    "«Держись за красную шапочку — здесь только заглушка и попкорн».",
    "«На дне Андрей смотрел в отражение. Мы — в пустую ленту отзывов».",
    "«Кин-дза-дза! Правильные люди отзывы пока не пишут».",
    "«Ночной Dozor: комментарии на карантине до рассвета».",
    "«Вы — не ваш отзыв!» — шепнул Нео и свернул секцию.",
    "«Грибоедочка сказала: комментарии в другом измерении».",
    "«Звонит, кто-то звонит!» — это не отзыв, это оповещение об отключении.",
    "«Как говорил Tarantino: ревью будет… позже».",
    "«Я ещё вернусь в прокат!» — отзывы пока в командировке.",
    "«Они срубили глобальную сеть» — отзывы всё равно молчат, как финал без титров.",
    "«May the Force be with you» — но не с отзывами, они на светлой стороне отдыхают.",
    "«Here's Johnny!» — а секция комментариев сейчас за закрытой дверью.",
    "«Why so serious?» — потому что модерация ушла на перекур между сеансами.",
    "«Keep your friends close» — отзывы ближе некуда, просто их временно спрятали.",
    "«Life is like a box of chocolates» — никогда не знаешь, когда вернутся комментарии.",
    "«I'm the king of the world!» — крикнул Джек, отзывы тоже ушли на борт.",
    "«Отличное кино!» — написал бы кто-нибудь, если бы секция работала.",
    "«Путёвку давай, обратно» — комментарии уже на вылет в космос.",
    "«Люди как люди… с попкорном, но без отзывов» — сказал бы Пелевин.",
    "«ВААААСЯ!» — отзывы временно в отпуске на курорте сценаристов.",
] as const

function createSeededRandom(seed: number): () => number {
    let state = Math.abs(seed) || 1
    return () => {
        state = (state * 1664525 + 1013904223) >>> 0
        return state / 0x100000000
    }
}

function shuffledUniquePhraseIndices(count: number, seed: number): number[] {
    const total = COMMENTS_DISABLED_MEME_PHRASES.length
    const indices = Array.from({ length: total }, (_, index) => index)
    const random = createSeededRandom(seed)

    for (let i = indices.length - 1; i > 0; i--) {
        const j = Math.floor(random() * (i + 1))
        ;[indices[i], indices[j]] = [indices[j], indices[i]]
    }

    return indices.slice(0, Math.min(count, total))
}

function seededIndex(seed: number, length: number): number {
    return Math.abs(seed) % length
}

function pickPhrase(seed: number): string {
    return COMMENTS_DISABLED_MEME_PHRASES[seededIndex(seed, COMMENTS_DISABLED_MEME_PHRASES.length)]
}

export function isDisabledCommentBody(body: string): boolean {
    return DISABLED_PATTERN.test(body.trim())
}

export function isCommentsDisabledStub(comments: FilmComment[]): boolean {
    return comments.some(comment => isDisabledCommentBody(comment.body))
}

export function filterRealComments(comments: FilmComment[]): FilmComment[] {
    return comments.filter(comment => !isDisabledCommentBody(comment.body))
}

/** Подменяет заглушку API шуточным текстом, сохраняя имя, рейтинг и id пользователя. */
export function substituteDisabledCommentBodies(comments: FilmComment[], filmId?: number): FilmComment[] {
    const base = filmId ?? 1
    const disabledCount = comments.filter(comment => isDisabledCommentBody(comment.body)).length
    const phraseIndices = shuffledUniquePhraseIndices(disabledCount, base)
    let phraseCursor = 0

    return comments.map(comment => {
        if (!isDisabledCommentBody(comment.body)) return comment

        const phraseIndex = phraseIndices[phraseCursor]
        phraseCursor += 1
        return { ...comment, body: COMMENTS_DISABLED_MEME_PHRASES[phraseIndex] }
    })
}

export function getRandomCommentsDisabledPhrase(seed?: number): string {
    return pickPhrase(seed ?? Math.floor(Math.random() * COMMENTS_DISABLED_MEME_PHRASES.length))
}
